import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'shortNumber',
  standalone: true,
})
export class ShortNumberPipe implements PipeTransform {
  transform(value: number | null | undefined, digits = 1): string {
    if (value === null || value === undefined || Number.isNaN(value)) {
      return '';
    }

    const units = [
      { value: 1e9, symbol: 'B' },
      { value: 1e6, symbol: 'M' },
      { value: 1e3, symbol: 'k' },
    ];

    for (const unit of units) {
      if (Math.abs(value) >= unit.value) {
        return (
          (value / unit.value)
            .toFixed(digits)
            .replace(/\.0+$|(\.\d*[1-9])0+$/, '$1') + unit.symbol
        );
      }
    }

    return value.toString();
  }
}
